import { useMemo } from 'react';

const usePersistSearchParams = (): string => {
  const urlParams = useMemo(() => window.location.href?.split('?')?.[1] ?? '', []);

  return `?${urlParams}`;
};
export default usePersistSearchParams;
